import FilterDropdownShell from './FilterDropdownShell';

// Single-select, tick-mark style dropdown - matches DateFilterButton's own option list exactly.
const SingleSelectDropdown = ({ options, selectedValue, onSelect, primary, width }) => {
  const selectedLabel = options.find((option) => option.value === selectedValue)?.label ?? selectedValue;

  return (
    <FilterDropdownShell label={selectedLabel} primary={primary} width={width}>
      {({ hideFilters }) =>
        options.map((option) => (
          <button
            key={option.value}
            className='settings-button setting-item general-button d-block text-left w-100 px-4 position-relative'
            onClick={() => {
              onSelect(option.value);
              hideFilters();
            }}
          >
            {option.label}
            {selectedValue === option.value && <span className='icon-tick topic-selected-mark paragraph-p4' />}
          </button>
        ))
      }
    </FilterDropdownShell>
  );
};

export default SingleSelectDropdown;
